import { styled } from "styled-components";

export const CategoryViewContainer = styled.div`
  flex: 1;
  background-color: #fff;
  padding: 24px;
  a {
    text-decoration-line: none;
    color: #383838;
  }
`;
